import React, { memo, forwardRef } from "react";
const SvgCapitalV = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M17.7 21.86c-.12.307-.253.553-.4.74-.146.187-.3.333-.46.44-.146.093-.3.153-.46.18a2.347 2.347 0 01-.86 0 1.429 1.429 0 01-.46-.18 2.279 2.279 0 01-.44-.44 2.923 2.923 0 01-.4-.74l-4.4-11.1a2.363 2.363 0 01-.14-.44 3.377 3.377 0 01-.02-.32c0-.36.12-.66.36-.9s.547-.36.92-.36c.213 0 .44.067.68.2.24.133.447.433.62.9l3.74 9.98h.08L19.78 9.8c.16-.427.354-.707.58-.84.24-.147.474-.22.7-.22.347 0 .647.113.9.34.253.227.38.52.38.88 0 .08-.013.187-.04.32a2.893 2.893 0 01-.14.46L17.7 21.86z"
      />
    </svg>
  );
});
SvgCapitalV.displayName = "SvgCapitalV";
const MemoForwardRef = memo(SvgCapitalV);
export default MemoForwardRef;
